import * as Config from '../../../config';
import React from 'react';
import PropTypes from 'prop-types';

import CoverSplit from '../common/CoverSplit';

function Playlist({ id, name, countTracks, onClick, isSelected, cover, style, length_ms = null }) {
  return (
    <div className={`menu-left-container ${isSelected && `selected`} `} onClick={onClick} >
      <div className={`flexRow playlist-container ${isSelected && `selected`}`} style={{...style}} >
        <CoverSplit name={name} images={cover} size={Config.MENU_COVER_SIZE} />
        <div className={`flexColumn playlist-menu-infos type-small`}>
          <span className={`type-light type-medium fz14`} >{Config.limitString(name, 45, false)}</span>
          <span className={`playlist-menu-owner`}>{`${countTracks} tracks • ${Config.msToHourMin(length_ms)}`}</span>
        </div>
      </div>
    </div>
  )
}

Playlist.propTypes = {
  id: PropTypes.any.isRequired,
  name: PropTypes.string.isRequired,
  countTracks: PropTypes.number.isRequired,
  cover: PropTypes.array.isRequired,
  style: PropTypes.object,
  onClick: PropTypes.func,
  isSelected: PropTypes.bool
}

export default Playlist;
